import { useCallback, useState } from 'react';
import type { CellKey } from './types';

/** The blank row's id in the refused-cell mark; no real row uses it. */
export const NEW_ROW_ID = '__new-row__';

/** `at` changes on every refusal, so the same cell refused twice flashes twice. */
export type RefusedCell = CellKey & { at: number };

/**
 * A paste or clear a cell can't take flashes it red instead of doing nothing.
 * The last copied cell gets a moving dashed border until Escape. Both are kept
 * by row id, so they survive sorting and reloads.
 */
export function useCellMarks() {
  const [refused, setRefused] = useState<RefusedCell | null>(null);
  const [copied, setCopied] = useState<CellKey | null>(null);
  const refuse = useCallback(
    (rowId: string, columnId: string) =>
      setRefused(prev => ({ rowId, columnId, at: (prev?.at ?? 0) + 1 })),
    []
  );
  return { refused, copied, refuse, setCopied };
}

export type CellMarks = ReturnType<typeof useCellMarks>;
